import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.2 8.807v5.066a1.6 1.6 0 0 1-1.6 1.6H6.4a1.6 1.6 0 0 1-1.6-1.6V8.807M15.2 4.54H4.8a.8.8 0 0 0-.8.8v1.6h12v-1.6a.8.8 0 0 0-.8-.8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M11.067 9.073H8.933a.8.8 0 0 0-.8.8v.534a.8.8 0 0 0 .8.8h2.134a.8.8 0 0 0 .8-.8v-.534a.8.8 0 0 0-.8-.8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);